import { Notify } from 'utils';

export const errorCodes: any = {
  500: {
    title: 'Server error',
    message: 'We are working to resolve it'
  },
  1010: {
    title: 'Error while applying charge',
    message: 'Only percentage or cash value is required'
  },
  1017: {
    title: 'Error while applying charge',
    message: 'Advisor charge of this type for this policy was already requested'
  },
  1031: {
    title: 'Please fix bellow errors',
    message: 'Sum of the applied charge do not match requested'
  }
};

export const generateErrMesage = ({ response }: any) => {
  const { data } = response;

  if (data && data.code) {
    const isValidErrCode = errorCodes[data.code];

    if (isValidErrCode) {
      Notify.error(isValidErrCode.title, isValidErrCode.message);
    } else if (data.message) {
      Notify.error(data.message);
    } else {
      Notify.error('Unknown error', 'Please contact administrator');
    }
  }
};
